/* eslint-disable no-var */

import { DynamicQueryMethod } from 'common/dynamicquery/dynamic-query-method';
import { DynamicQuery } from 'common/dynamicquery/dynamic-query-class';

export class DynamicQueryMessageAdapter {
  constructor(private _dynamicQuery: DynamicQuery) {}

  forwardMessage(method: DynamicQueryMethod, params) {
    switch (method) {
      case 'updateRow':
        this._dynamicQuery.updateRow(params.Row);
        break;
      case 'deleteRow':
        this._dynamicQuery.deleteRow(params.ID);
        break;
      case 'load':
        this._loadRows(this._dynamicQuery, params.Rows.keys, params.Rows.values);
        break;
      case 'startLoad':
        this._dynamicQuery.init(params.KeyField);

        if (params.Rows) {
          this._loadRows(this._dynamicQuery, params.Rows.keys, params.Rows.values);
        }
        break;
      case 'stopLoad':
        this._dynamicQuery.setDone();
        break;
      default:
        throw 'Not implemented method.';
    }
  }

  private _loadRows(dq, keys, values) {
    if (keys && keys.length) {
      for (var i = 0, length = values.length; i < length; i++) {
        var row = this._buildRow(keys, values[i]);
        dq.updateRow(row);
      }
    }
  }

  private _buildRow(keys, values) {
    var row = {};
    for (var i = 0, length = keys.length; i < length; i++) {
      row[keys[i]] = values[i];
    }

    return row;
  }
}
